<template>
    <div id="rating-section" class="d-flex">
        <div class="stars-section d-flex">
            <div class="text-wrapper d-flex" :style="{ position: 'relative' }">
                <p v-for="(text, index) in starsText" :key="index" class="my-0">{{ text }}</p>
                <span class="required-text" :class="'invalid'">(obrigatório)</span>
            </div>
            <StarsComponent @update-selection="updateSelection('stars', $event)" />
        </div>
        <div id="recommend-section">
            <div class="text-wrapper d-flex">
                <span>{{ recommendText }}</span>
                <span class="required-text" :class="'invalid'">(obrigatório)</span>
            </div>
            <BinaryChoiceComponent
                :colored-theme="true"
                @update-selection="updateSelection('recommend', $event)"
            />
        </div>
    </div>
</template>

<script>
    import BinaryChoiceComponent from '../form-components/BinaryChoiceComponent.vue';
    import StarsComponent from '../form-components/StarsComponent.vue';

    export default {
        name: 'RatingSection',
        props: {
            title: {
                type: String,
                required: true,
            },
        },
        components: { StarsComponent, BinaryChoiceComponent },
        mounted() {},
        data() {
            return {
                starsText: [
                    `Quantas estrelas "${this.title}" merece?`,
                    'Avalie de 1 a 5 estrelas considerando sua satisfação com o produto recebido.',
                ],
                recommendText: 'Você recomenda este produto?',
            };
        },
        methods: {
            updateSelection(field, value) {
                this.$emit('update-form', { field, value });
            },
        },
    };
</script>
